import { render } from "./DashboardVendor.vue?vue&type=template&id=231b7d79"
import script from "./DashboardVendor.vue?vue&type=script&lang=js"
export * from "./DashboardVendor.vue?vue&type=script&lang=js"

import exportComponent from "/Users/suryaardiansah/Documents/Project/Programming/Vue/BACKUPP/vue-backup/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__